module.exports = __webpack_public_path__ + "static/media/becomeProvider.eb55b133.svg";